import React from "react";

import { X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import NeftModal from "../Handholder/NeftModal";
import moment from "moment";

import ConfirmationModal from "./ConfirmationModal";

export default function StateChangeModalSPM(props) {
	const renderStateChangeAuditLog = () => {
		if (props.stateAuditLog) {
			let rows = props.stateAuditLog.map((e) => {
				return (
					<tr>
						<td>{e["refCurrentState"]}</td>
						<td>
							{moment(moment.utc(e["dtCreated"]).toDate()).format(
								"MMMM Do YYYY, h:mm:ss a"
							)}
						</td>
						<td>{e["refFacilitator"]}</td>
					</tr>
				);
			});
			return (
				<table>
					<th>Current State</th>
					<th>Date</th>
					<th>Updated by</th>
					{rows}
				</table>
			);
		} else return "";

		 
	};
	return (
		<Modal
			isOpen={props.isOpen}
			onRequestClose={props.toggleModal}
			ariaHideApp={false}
		>
			<ModalContent>
				{props.stateAuditLog ? (
					<div>
						<div>
							<div className="status-column">
								<div className="p-2 modal-header-bar">
									<span>Change Status Log</span>
									<button
										type="button"
										className="close"
										aria-label="Close"
										onClick={props.toggleModal}
									>
										<X
											style={{ pointerEvents: "none" }}
											color="white"
										/>
									</button>
								</div>
								<div style={{ padding: "20px" }}>
									<div
										style={{
											overflowY: "scroll",
											height: "295px",
											marginTop: "20px",
											paddingLeft: 0,
											paddingRight: "40px",
										}}
									>
										{renderStateChangeAuditLog()}
									</div>
								</div>
							</div>
						</div>
					</div>
				)

	
				: (
					""
				)}
			</ModalContent>
		</Modal>
	);
}
